import React,{useState} from 'react';

const IncomeReviewed = ({ onNext }) => {
  const [clickedButton, setClickedButton] = useState(null);
   const handleClick = (e) => {
      const buttonValue = e.target.value;
      setClickedButton(buttonValue);
      onNext(buttonValue);
   };

  return (
  <>
    <div className="qs-card__head"><h2 className="qs-card__title">Was Your Income Reviewed?</h2></div>
    <div className="qs-card__body">
      <p className="qs-card__sub">Did the lender ask for details of your income and expenses before approving the credit card?</p>
      <div className="qs-actions">
        <button 
          type="button"
          value={415}
          className={`qs-btn qs-btn--optn ${clickedButton == '415' ? 'btn-active' : ''}`} 
          onClick={handleClick}>
            Yes</button>
        <button 
          type="button" 
          value={416}
          className={`qs-btn qs-btn--optn ${clickedButton == '416' ? 'btn-active' : ''}`} 
          onClick={handleClick}>
            No</button>
      </div>
    </div>
  </>
  
);
   };

export default IncomeReviewed;
